export class Controller {

    /** @ngInject */
    constructor(
    		Alert,
    		UsersResource,
    ) {
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    $onInit() {
    }
    
    unpause(account) {
        this.isUnpausing = true;
        this.UsersResource
            .unpauseCompanyUser(this.companyId, account.id)
            .then(() => {
            	var index = this.pausedUsers.indexOf(account);
                this.numberOfUsers.pausedUsers -= 1;
            	this.pausedUsers.splice(index,1);
                account.status = 'ACTIVE';
                this.Alert('success', 'company.user-directories.manage-user.unpaused');
            })
            .finally(() => this.isUnpausing = false)

    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/paused-users/paused-users.controller.js